import { isSvgIcon, SvgIcon } from '@/vantage/components/atoms/SvgIcon.atom';
import { Icon } from '@seeqdev/qomponents/';

export interface MultiTypeIconProps {
  icon: string;
  iconFill: string;
  type?: 'color' | 'white' | 'gray' | 'dark-gray';
  extraClassNames?: string;
  small?: boolean;
  large?: boolean;
  height?: string;
  width?: string;
  testId?: string;
}

/**
 * Renders either a FontAwesome icon or custom icon or an icon that has an SVG icon path
 *
 * @param icon - the icon
 * @param iconFill - the icon fill color
 * @param type - the icon type
 * @param extraClassNames - extra class names to apply
 * @param [large=false] - optional large
 * @param [small=false] - optional small
 * @param [height='19'] - optional height
 * @param [width='19'] - optional width
 * @param testId TestID to add to component
 */
export const MultiTypeIcon: React.FunctionComponent<MultiTypeIconProps> = ({
  icon = '',
  iconFill,
  type = 'white',
  extraClassNames,
  small = false,
  large = false,
  height = '19',
  width = '19',
  testId,
}) => {
  return (
    <>
      {isSvgIcon(icon) ? (
        <span className={`${iconFill === 'red' ? 'sq-flag-icon-color' : 'sq-text-color'}`}>
          <SvgIcon
            icon={icon}
            iconFill={iconFill === 'white' ? 'transparent' : 'currentColor'}
            extraClassNames={`seeq-icon p2 ${extraClassNames}`}
            height={height}
            width={width}
            testId={testId}
          />
        </span>
      ) : (
        <Icon
          icon={icon}
          color={iconFill}
          type={type}
          extraClassNames={`seeq-icon p2 ${extraClassNames}`}
          testId={testId}
          small={small}
          large={large}
        />
      )}
    </>
  );
};
